<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRow>
      <img src="img/RFwhite.png" style="width: 100px; margin: auto" />
      <!-- <span style="font-size: 30px; padding-top: 19px">Smart Herd</span> -->
      <!-- <h2 style="padding-top: 20px">Smart Herd</h2> -->
    </CRow>

    <!-- <CSidebarBrand class="d-md-down-none" to="/">
   
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size"
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>-->

    <CRenderFunction
      v-if="this.user.userRole == 'support'"
      flat
      :contentToRender="$options.support"
    />

    <CRenderFunction
      v-if="this.user.userRole == 'admin'"
      flat
      :contentToRender="$options.admin"
    />
    <CRenderFunction
      v-if="this.user.userRole == 'marketing'"
      flat
      :contentToRender="$options.marketing"
    />
    <CRenderFunction
      v-if="this.user.userRole == 'user'"
      flat
      :contentToRender="$options.userRole"
    />
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import admin from "./admin_nav";
import support from "./support";
import marketing from "./marketing";
import userRole from "./users";

export default {
  name: "TheSidebar",
  nav,
  admin,
  support,
  marketing,
  userRole,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("data")); //push all data to this.articles
  },
};
</script>
<style scoped>
.c-sidebar.c-sidebar-fixed {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1030;
  background: #08103b;

  font-size: initial;
}

.c-sidebar .c-sidebar-nav-link,
.c-sidebar .c-sidebar-nav-dropdown-toggle {
  color: ghostwhite;
  background: transparent;
}
.c-sidebar .c-sidebar-nav-link.c-active .c-sidebar-nav-icon,
.c-sidebar .c-active.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  color: #fff;
  height: 21px;
}
.c-sidebar-nav-icon {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 56px;
  flex: 0 0 56px;
  /* height: 1.09375rem; */
  font-size: 1.09375rem;
  text-align: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  fill: currentColor;
  height: 25px !important;
  color: white;
}
.c-sidebar .c-sidebar-nav-link .c-sidebar-nav-icon,
.c-sidebar .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  /* color: rgba(255, 255, 255, 0.5); */
  height: 28px !important;
  color: white !important;
}

.c-sidebar .c-sidebar-nav-link,
.c-sidebar .c-sidebar-nav-dropdown-toggle {
  /* color: rgba(255, 255, 255, 0.8); */
  background: transparent;
  color: white;
}
</style>
